import {useNavigate} from "react-router-dom";
import {useCookies} from "react-cookie";
import {HOME_URL} from "../lib/const.ts";
import ReactGA from "react-ga4";
import {DynamicTemplateLoader} from "../components/ui/DynamicTemplateLoader.tsx";
import {useEffect} from "react";

export const Home = () => {
    const navigate = useNavigate();
    const [cookies, setCookie] = useCookies([import.meta.env.VITE_COOKIE_NAME]);

    ReactGA.send({
        hitType: 'pageview',
        page: '/',
    })

    const handleBegin = () => {
        setCookie("points", JSON.stringify({}), { expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 100)});
        navigate("/quiz");
    };

    const handleSkip = () => {
        setCookie(import.meta.env.VITE_COOKIE_NAME, "1", {
            secure: true,
            path: '/',
        });

        ReactGA.event({
            category: "quiz",
            action: "skip",
        });

        setTimeout(() => {
            window.location.href = HOME_URL;
        }, 1000);
    };

    useEffect(() => {
        if (import.meta.env.VITE_SKIP_HOME === "true") {
            handleBegin();
        }
    }, []);

    return (
        <DynamicTemplateLoader screenType={"HomeScreen"} componentProps={{
            onSkipQuiz: handleSkip,
            onBeginQuiz: handleBegin,
        }} />
    );
};
